export const BANKS: any =  [{
    "stateName": "Andhra Pradesh",
}, 
{
    "stateName": "Arunachal Pradesh",
},
{
    "stateName": "Assam",
},
{
    "stateName": "Bihar",
},
{
    "stateName": "Chhattisgarh",
}, 
{
    "stateName": "Dadra and Nagar Haveli",
},

{
    "stateName": "Daman and Diu",
},
{
    "stateName": "Delhi",
},
{
    "stateName": "Goa",
},
{
    "stateName": "Gujarat",
},
{
    "stateName": "Haryana",
},
{
    "stateName": "Himachal Pradesh",
},
{
    "stateName": "Jammu and Kashmir",
},

{
    "stateName": "Jharkhand",
},
{
    "stateName": "Karnataka",
},
{
    "stateName": "Kerala",
},
{
    "stateName": "Madhya Pradesh",
},
{
    "stateName": "Maharashtra",
},
{
    "stateName": "Manipur",
},
{
    "stateName": "Meghalaya",
},
{
    "stateName": "Mizoram",
},
{
    "stateName": "Nagaland",
},
{
    "stateName": "Orissa",
},
{
    "stateName": "Pondicherry (Puducherry)",
},
{
    "stateName": "Punjab",
},
{
    "stateName": "Rajasthan",
},
{
    "stateName": "Sikkim",
},

{
    "stateName": "Telangana",
},
{
    "stateName": "Tamil Nadu",
},
{
    "stateName": "Tripura",
},
{
    "stateName": "Uttar Pradesh",
},
{
    "stateName": "Uttarakhand",
},
{
    "stateName": "West Bengal",
}
]
  export interface Bank {
    id: string;
    name: string;
  }